<template>
    <DForm @submit.prevent="submitForm">
        <div
            v-for="(translation, key) in translations"
            :key="key"
        >
            <DCard
                padding
                :title="defaultLanguageLabel(translation)"
                class="mb-3"
            >
                <DFormRow
                    :label="__('products.products.form.name')"
                    is-required
                >
                    <DInput
                        id="name"
                        v-model="form.translations[key].name.value"
                        :placeholder="__('products.products.form.name')"
                        :is-valid="isFormFieldValid('name')"
                        maxlength="255"
                    />
                </DFormRow>
                <DFormRow
                    :label="__('products.products.form.invoice_text')"
                    :hint="__('products.products.form.invoice_text_helper_text')"
                >
                    <DFormTextarea
                        id="invoice_text"
                        v-model="form.translations[key].invoice_text.value"
                        :placeholder="__('products.products.form.invoice_text')"
                        rows="5"
                    />
                </DFormRow>
                <DFormRow
                    :label="__('products.products.form.terms_and_conditions.label')"
                    :hint="__('products.products.form.terms_and_conditions.description')"
                >
                    <DFormTextarea
                        id="terms_and_conditions"
                        v-model="form.translations[key].terms_and_conditions.value"
                        :placeholder="__('products.products.form.terms_and_conditions.label')"
                        rows="5"
                    />
                </DFormRow>
                <DFormRow
                    :label="__('products.products.form.terms_and_conditions_link_label.label')"
                    :hint="__('products.products.form.terms_and_conditions_link_label.description')"
                >
                    <DInput
                        id="terms_and_conditions_link_label"
                        v-model="form.translations[key].terms_and_conditions_link_label.value"
                        :placeholder="__('products.products.form.terms_and_conditions_link_label.label')"
                        rows="5"
                    />
                </DFormRow>
                <DFormRow
                    :label="__('products.products.form.terms_and_conditions_link_label_2.label')"
                    :hint="__('products.products.form.terms_and_conditions_link_label_2.description')"
                >
                    <DInput
                        id="terms_and_conditions_link_label_2"
                        v-model="form.translations[key].terms_and_conditions_link_label_2.value"
                        :placeholder="__('products.products.form.terms_and_conditions_link_label_2.label')"
                        rows="5"
                    />
                </DFormRow>
                <DFormRow
                    :label="__('products.products.form.terms_and_conditions_link_label_3.label')"
                    :hint="__('products.products.form.terms_and_conditions_link_label_3.description')"
                >
                    <DInput
                        id="terms_and_conditions_link_label_3"
                        v-model="form.translations[key].terms_and_conditions_link_label_3.value"
                        :placeholder="__('products.products.form.terms_and_conditions_link_label_3.label')"
                        rows="5"
                    />
                </DFormRow>
            </DCard>
        </div>
        <DFormControls
            :cancel-route="product.isAddon ? $route('products.product-addons.edit', { product: props.product }) : $route('products.products.edit', { product: props.product })"
            @submit="submitForm"
        />
    </DForm>
</template>

<script setup>
import { route } from '~@/Composables/route'
import { useForm } from '@inertiajs/vue3'
import { __ } from '~@/Composables/translation'

const props = defineProps({
    product: {
        type: Object,
        default: () => {
            return {}
        }
    },
    translations: {
        type: Object,
        default: () => {
            return {}
        }
    },
    defaultTenantLanguage: {
        type: String,
        default: ''
    }
})

const form = useForm({
    translations: props.translations
})

const submitForm = () => {
    form.post(route('products.products.translations-update', { product: props.product ?? 0 }))
}

const defaultLanguageLabel = (translation) => props.defaultTenantLanguage.value === translation.language.value ? `${__('settings.default_customer_language')} ${translation.language.label}` : translation.language.label

</script>

<style scoped lang="scss">

</style>
